/** Page-level widths; use `BandContent $maxWidth={theme.layout.contentWidth}` for a centred content column. */
/* the card gap's top end: also what a card row's image `sizes` subtract at full width */
const CARD_GAP_MAX = "2.75rem";

export const layout = {
  /* the narrow content column: homepage mock v24.09 1100 at 1920 (x 410–1510: boxes, split sections, search); the footer shares it */
  contentWidth: "1100px",
  /* side inset of a page that scales with the viewport: 24 px at 360 (the homepage mock; the category/loyalty mocks had 30/35 — one
     value for the whole site) up to 128 px. rem, not em: it must not follow a local font-size */
  pageGutter: "clamp(1.5rem, 6.6667vw, 8rem)",
  /* the narrower inset of the dense pages (product page, cart, checkout, account): 16 px at 360, 32 px from 720 */
  compactGutter: "clamp(1rem, 4.4444vw, 2rem)",
  /* air between two homepage sections: 36 px at 360 → 80 px at 1440 (24.09 mock: median gap ~33 at 360, ~78 at 1920), same anchors as the type scale */
  sectionGap: "clamp(2.25rem, 1.3333rem + 4.0741vw, 5rem)",
  /* twice sectionGap (72 → 160 px): before a long closing section that should read as set apart, e.g. the category article */
  sectionGapLarge: "clamp(4.5rem, 2.6667rem + 8.1481vw, 10rem)",
  /* gap between the cards / tiles of every homepage grid (product carousel, blog, social): 18 px at 360 → 44 at 1440, one value
     where the mock had 44 / 78 / 32 / 26. The carousel passes the two ends to Swiper as numbers (spaceBetween takes px only) */
  cardGap: `clamp(1.125rem, 0.5833rem + 2.4074vw, ${CARD_GAP_MAX})`,
  cardGapMax: CARD_GAP_MAX,
  /* cap of a column section without its own background (steps, tiles, level cards): what pageGutter leaves at 1920 (loyalty mock 1640;
     the homepage mock runs 1724), so it only engages on screens wider than the mock */
  sectionWidth: "1640px",
  /* one vertical air for a page section: under its title band, under its content (Section's default spacing) and between its
     stacked rows. rem, so a section reads the same next to a small or a large heading */
  sectionAir: "3rem",
  /* system pages (login gate, cart, checkout, account): main | gap | aside, 1010 in all; fr, so the columns keep their ratio on a narrower viewport */
  systemColumns: "minmax(0, 514fr) minmax(0, 460fr)",
  systemColumnGap: "36px",
  systemWidth: "1010px",
  /* the main column alone (a system page without an aside) */
  systemMainWidth: "514px",
  /* the account page's menu column; menu + content share systemWidth */
  accountMenuWidth: "240px",
  /* caps of a sheet / centred dialog on every width — a bottom sheet on a tablet would otherwise run edge to edge */
  sheetWidth: "500px",
  dialogWidth: "440px",
  /* a comfortable line of body copy (~70 characters): running text stops growing here */
  measure: "42rem",
  /* the hamburger menu drawer: the full screen on a phone, no wider than this */
  menuWidth: "425px",
  /* how far below the viewport top an in-page anchor lands: the sticky header is 64 px on a phone, 90 on desktop, plus a little air */
  anchorOffset: "6rem",
};
